import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {RateSummaryNeedsAttention} from "components/rate-summary-needs-atention/RateSummaryNeedsAtention";
import {RateSummaryPerformance} from "components/rate-summary-performance/RateSummaryPerformance";
import {RateSummaryOpportunities} from "components/rate-summary-opportunities/RateSummaryOpportunities";
import {RateSummarySnapshotMetrics} from "components/rate-summary-snapshot-metrics/RateSummarySnapshotMetrics";
import {RateSummaryOverview} from "components/rate-summary-overview/RateSummaryOverview";
import {AiGeneratedBadge} from "components/ai-generated-badge/AiGeneratedBadge";
import {fetchRateSummary} from "store/rateSummarySlice";
import {RootState, AppDispatch} from "store/store";
import styles from "./RateSummary.module.scss";

interface RateSummaryProps {
    unitId: string;
}

export const RateSummary: React.FC<RateSummaryProps> = ({unitId}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {data, loading, error} = useSelector((state: RootState) => state.rateSummary);

    useEffect(() => {
        dispatch(fetchRateSummary(parseInt(unitId, 10)));
    }, [dispatch, unitId]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!data) {
        return <div>No data available</div>;
    }

    return (
        <div className={styles.container}>
            {/* Snapshots */}
            <h1>Snapshots</h1>
            <hr />
            <RateSummarySnapshotMetrics metrics={data.snapshotMetrics} />

            {/* Overview */}
            <h1>
                Overview
                <AiGeneratedBadge />
            </h1>
            <hr />
            <RateSummaryOverview summary={data.summary} keyActions={data.keyActions} />

            {/* Performance */}
            <h1>Performance</h1>
            <hr />
            <RateSummaryPerformance rateInsights={data.rateInsights} revenueData={data.revenueData} />

            {/* Needs Attention */}
            <h1>
                Needs Attention
                <AiGeneratedBadge />
            </h1>
            <hr />
            <RateSummaryNeedsAttention items={data.needsAttentionItems} />

            {/* Opportunities */}
            <h1>
                Opportunities
                <AiGeneratedBadge />
            </h1>
            <hr />
            <RateSummaryOpportunities items={data.opportunitiesItems} />
        </div>
    );
}; 